function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { AllExceptBusinessListingTypeKeys, getPrimaryPropertyTypesForListingType, PropertyType } from '@domain-group/fe-allhomes-library/lib/node';
import { parseSlugs } from '../../utils/parse-slugs';
import { MultiValueSearchQueryField } from '../multi-value-search-query-field';
export class PropertyTypesFilter extends MultiValueSearchQueryField {
  get validListingTypes() {
    return AllExceptBusinessListingTypeKeys;
  }
  constructor(searchOptions, value) {
    super(searchOptions, getPrimaryPropertyTypesForListingType(searchOptions.listingType), value);
    _defineProperty(this, "urlSlug", PropertyTypesFilter.urlSlug);
  }
  static fromUrlParameters(searchOptions, q, p) {
    return new PropertyTypesFilter(searchOptions, parseSlugs(PropertyType, q[PropertyTypesFilter.urlSlug] || p.propertyType));
  }
}
_defineProperty(PropertyTypesFilter, "urlSlug", 'propertytypes');